export enum OfferType {
    preEvent = 1,
    live = 2
}

export enum OfferStatus {
    active = 'active',
    stop = 'stop',
    block = 'block',
    finished = 'finished',
    canceled = 'canceled'
}

export enum OddStatus {
    active = 'active',
    stop = 'stop',
    block = 'block',
    finished = 'finished',
    lost = 'lost',
    refund = 'refund',
    win = 'win',
}

export enum EventCategory {
    OUTRIGHT = 'OUTRIGHT'
}

export enum SuperOfferKeys {
    superCota = 'superKvota',
    superExtra = 'superExtra',
}

export enum VideoProviderType {
    IMG = 1,
    BETRADAR = 2,
    YOUTUBE = 4,
    TWITCH = 5,
    PERFORM = 6,
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/models/offer/enums.ts